import React, { CSSProperties } from "react";

import { styled } from "@styles/theme";
import { scrollbar } from "@styles/Scrollbar";
import { Box } from "./ResponsiveBox";

export type Props = {
  ariaLabel: string;
  value?: string;
  placeholder?: string;
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
  height?: number;
  width?: number;
  style?: CSSProperties;
};

type TextAreaProps = {
  onChange?: React.ChangeEventHandler<HTMLTextAreaElement>;
};

const InputContainer = styled(Box)<{ width?: number }>`
  position: relative;
  width: ${(p) => p.width || "100%"};
`;

const TextAreaContainer = styled.textarea<Props & TextAreaProps>`
  width: 100%;
  height: ${(p) => p.height || "119px"};
  ${scrollbar}
  overflow-y: auto;
  padding: ${(p) => p.theme.spacing.md};
  border: 1px solid ${(p) => p.theme.colors.neutral["400"]};
  border-radius: ${(p) => p.theme.radius};
  color: ${(p) => p.theme.colors.primary["500"]};
  font-family: ${(p) => p.theme.fonts.main};
  font-size: 14px;
  font-weight: 400;
  resize: none;
  outline: none;

  &:focus {
    border: 1px solid ${(p) => p.theme.colors.blue["400"]};
  }
`;

export const TextArea = ({
  ariaLabel,
  value,
  placeholder,
  onChange,
  height,
  width,
}: Props & TextAreaProps) => {
  return (
    <InputContainer width={width}>
      <TextAreaContainer
        ariaLabel={ariaLabel}
        value={value}
        placeholder={placeholder}
        onChange={onChange}
        height={height}
        width={width}
      />
    </InputContainer>
  );
};
